module.exports = __webpack_public_path__ + "img/file-text-white.f14f419f.svg";